export const MAX_CARTAGE_PAY_PAYOUT_CENTS = 25_000_000
